<template>
  <p class="appointmentTxt" style="text-align: left;">
    兒科門診時間：<br />
    早診&nbsp;&nbsp;<span>09:00&nbsp;-&nbsp;12:00</span>。
    <br />現場掛號、預約報到<span> 11:30</span> 截止<br />
    午診&nbsp;&nbsp;<span>13:30&nbsp;-&nbsp;16:30</span>。
    <br />現場掛號、預約報到<span> 16:00</span>
    截止
    <br /><br />
    婦產科門診時間：<br />
    早診&nbsp;&nbsp;<span>09:00&nbsp;-&nbsp;12:30</span>。
    <br />現場掛號、預約報到<span> 12:00</span> 截止<br />
    午診&nbsp;&nbsp;<span>13:30&nbsp;-&nbsp;17:00</span>。
    <br />現場掛號、預約報到<span> 16:30</span> 截止<br />
    夜診&nbsp;&nbsp;<span>18:00&nbsp;-&nbsp;21:30</span>。
    <br />現場掛號、預約報到<span> 21:00</span> 截止<br />
  </p>
</template>
